import AppExperience from '@/components/app-experience/'
import AppSlider from '@/components/app-slider/'
import AppGrid from '@/components/app-grid/'
import AppSound from '@/components/app-sound/'
import AppMenuTrigger from '@/components/app-menu-trigger/'

import WordingMixin from '@/mixins/Wording'
import SizesMixin from '@/mixins/Sizes'
import ScrollMixin from '@/mixins/Scroll'
import EventHubMixin from '@/mixins/EventHub.js'

export default
{
    name: 'app-main',

    mixins:
    [
        WordingMixin,
        SizesMixin,
        ScrollMixin,
        EventHubMixin
    ],

    components:
    {
        AppExperience,
        AppSlider,
        AppGrid,
        AppSound,
        AppMenuTrigger
    },

    data()
    {
        return {
            mainLogoVisible: false,
            topBackgroundVisible: false
        }
    },

    computed:
    {
        pageTransitionDuration: function()
        {
            let duration = 300

            if(this.$root.$previousRoute && this.$root.$previousRoute.name === 'menu')
            {
                duration = 2000
            }

            if(this.$route.name === 'menu')
            {
                duration = 1000
            }

            return {
                leave: duration,
                enter: duration
            }
        }
    },

    watch:
    {
        $route(newRoute, oldRoute)
        {
            this.mainLogoVisible = this.$route.name !== 'home' || this.sizes.width <= 767

            // Lang change
            if(newRoute.params.lang !== oldRoute.params.lang)
            {
                // Force reload
                window.location.reload()
            }
        }
    },

    created()
    {
        this.mainLogoVisible = this.$route.name !== 'home' || this.sizes.width <= 767
    },

    methods:
    {
        onButtonMouseEnter(_event)
        {
            const $inner = _event.target.querySelector('.js-inner')
            this.$eventHub.$emit('grid.focusItem', $inner)
        },

        onButtonMouseLeave()
        {
            this.$eventHub.$emit('grid.unfocusItem')
        },

        onPageEnter()
        {
            window.scrollTo(0, 0)
            this.$eventHub.$emit('main.pageEnter')
        },

        onResize()
        {
            this.mainLogoVisible = this.$route.name !== 'home' || this.sizes.width <= 767
        },

        onScroll()
        {
            this.topBackgroundVisible = this.scroll.current > 100 && (this.$route.name !== 'home' || this.sizes.width <= 579)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-main/script.js